import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Registry } from '@/registry.service';
import { DialogPopUpComponent } from '@components/dialog-pop-up/dialog-pop-up.component';
import { LoggerService } from '@services/logger.service';
import { Component, OnInit } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { ToastrService } from 'ngx-toastr';
import { WarrantyModel } from '@/models/tables/warranty.model';
import { WarrantyService } from '@services/data-source-tables/warranty.service';

@Component({
  selector: 'app-button-warranty-delete',
  templateUrl: '../../button.component.html',
  styleUrls: ['../../button.component.scss'],
})
export class ButtonDeleteWarrantyComponent extends ButtonComponent implements OnInit {
  faIcon = faTrashCan;
  private warrantyModel: WarrantyModel;
  private rowData: any;

  constructor(
    protected router: Router,
    public dialog: MatDialog,
    protected warrantyService: WarrantyService,
    protected toastr: ToastrService,
  ) {
    super(router, toastr);

    this.color = 'danger';
    this.additionalClass = 'py-0.5 px-2.5';
    this.showIcon = true;
    this.smallBtn = true;
  }

  ngOnInit() {
    this.warrantyModel = <WarrantyModel>this.rowData;
  }

  /**
   * Delete warranty
   */
  public actionClick(): void {
    let dialogRef = this.dialog.open(DialogPopUpComponent, {
      width: 'auto',
      panelClass: 'custom-modalbox',
    });

    this.setupPopup(dialogRef);

    dialogRef.afterClosed().subscribe((deleteSubAgent) => {
      if (deleteSubAgent) {
        this.warrantyService.deleteWarranty(this.warrantyModel.id).subscribe({
          next: () => {
            this.toastr.success('Garanzia cancellata correttamente!');

            Registry.getInstance().get('WarrantyComponent').loadWarranties();
          },
          error: (error) => {
            LoggerService.error('deleteWarranty failed!');
            LoggerService.error(error);

            this.toastr.error(`Errore durante la cancellazione della garanzia.`);
          },
          complete: () => {
            LoggerService.log('Request done');
          },
        });
      }
    });
  }

  private setupPopup(dialogRef: MatDialogRef<DialogPopUpComponent>) {
    dialogRef.componentInstance.title = 'Confermi di voler cancellare questa Garanzia?';
    dialogRef.componentInstance.content =
      'Attenzione una volta cancellata questa Garanzia non sarà più possibile recuperarla.';
    dialogRef.componentInstance.firstCTA = 'Si cancella';
    dialogRef.componentInstance.secondCTA = 'Annulla operazione';
    dialogRef.componentInstance.closeResultFirst = true;
    dialogRef.componentInstance.closeResultSecond = false;
  }
}
